var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-1"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-8"},[(_vm.getCallInfo != null)?_c('div',[_c('CallWindow')],1):_vm._e()])])])}
var staticRenderFns = []

export { render, staticRenderFns }